import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../contexts/SiteContext';

export function Footer() {
  const { settings, pages } = useSite();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-bold text-lg mb-2">{settings.site_name}</h3>
            <p className="text-sm text-muted-foreground">{settings.site_tagline}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Quick Links</h4>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/" 
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid="footer-link-home"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/projects"
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid="footer-link-projects"
                  >
                    Browse Projects
                  </Link>
                </li>
                {(Array.isArray(pages) ? pages : []).slice(0, 4).map((page) => (
                  <li key={page.slug}>
                    <Link
                      to={`/page/${page.slug}`}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                      data-testid={`footer-link-${page.slug}`}
                    >
                      {page.title}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link 
                    to="/contact" 
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid="footer-link-contact"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/api/rss.xml`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid="footer-link-rss"
                  >
                    RSS Feed
                  </a>
                </li>
                <li>
                  <a 
                    href="https://www.emergent.sh" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid="footer-link-emergent"
                  >
                    Made with Emergent
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Admin */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Admin</h4>
            <Link 
              to="/login" 
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
              data-testid="footer-link-login"
            >
              Admin Login
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border">
          <p className="text-center text-sm text-muted-foreground">
            &copy; {currentYear} {settings.site_name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
